// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"ed36a0a5","224":"b620749f","747":"bf13e372","996":"0226786e"}[chunkId] + ".chunk.js";
};